import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useRecentTopicsRecursive = (
  categoryId: string | undefined,
  limit: number = 10
) => {
  return useQuery({
    queryKey: ["recent-topics-recursive", categoryId, limit],
    enabled: !!categoryId,
    staleTime: 60_000,
    queryFn: async () => {
      const { data, error } = await (supabase as any).rpc(
        "get_recent_topics_recursive",
        { p_category_id: categoryId, p_limit: limit }
      );
      if (error) throw error;
      return (data || []) as any[];
    },
  });
};
